
import Vue from "vue";
import Component, { mixins } from "vue-class-component";
import WpBaseComponent from "./../components/wp-base-component";
import { AppSettings } from "web-platform-help-desk-core-frontend-ui";
import { ModuleType } from "web-platform-help-desk-core-frontend-ui/src/Global/module-type";

@Component({})
export default class App extends mixins(Vue, WpBaseComponent) {
  NavigationDrawer: boolean = false;
  NavExpansionPanel: number = 0; // Открыть первую вкладку по умолчанию

  get ToolbarTitle(): string {
    switch (AppSettings.ModuleType) {
      case ModuleType.Base:
        return "Поддержка клиентов";
      case ModuleType.Holland:
        return "Поддержка клиентов";
      case ModuleType.Gum:
        return "Поддержка клиентов";
      case ModuleType.Vdnh:
        return "Поддержка клиентов";
      case ModuleType.AkvaLushniki:
        return "Аквакомплекс - Лужники";
      case ModuleType.BobrLog:
        return "Поддержка клиентов";
      case ModuleType.LuzhnikiKatok:
        return "Лужники - каток";
      case ModuleType.LuzhnikiSber:
        return "Лужники - каток";
      case ModuleType.Buhtagold:
        return "Поддержка клиентов";
      case ModuleType.Elbrus:
        return "Поддержка клиентов";
      default:
        return "Поддержка клиентов";
    }
  }
  get NavPanels(): Array<Category> {
    let panels: Array<Category> = [];
    switch (AppSettings.ModuleType) {
      case ModuleType.Base:
        panels = [
          {
            Title: "Получение билетов",
            Options: [
              {
                Title: "Телеграмм бот",
                To: { name: "Telegram" },
                Icon: "mdi-forum",
              },
              {
                Title: "Поиск по реквизитам",
                To: { name: "GetByOrderInfo" },
                Icon: "mdi-text-box-search-outline",
              },
            ],
          },
          {
            Title: "Возврат билетов",
            Options: [
              {
                Title: "По реквизитам",
                To: { name: "RefundByOrderInfo" },
                Icon: "mdi-text-box-search-outline",
              },
            ],
          },
          {
            Title: "Администрирование",
            Options: [
              {
                Title: "Список",
                To: { name: "Admin" },
                Icon: "mdi-table-large",
              },
              {
                Title: "Настройки",
                To: { name: "Admin" },
                Icon: "mdi-table-large",
              },
            ],
          },
        ];
        break;
      case ModuleType.Holland:
        panels = [
          {
            Title: "Получение билетов",
            Options: [
              {
                Title: "Поиск по реквизитам",
                To: { name: "GetByOrderInfo" },
                Icon: "mdi-text-box-search-outline",
              },
            ],
          },
          {
            Title: "Возврат билетов",
            Options: [
              {
                Title: "По реквизитам",
                To: { name: "RefundByOrderInfo" },
                Icon: "mdi-text-box-search-outline",
              },
            ],
          },
        ];
        break;
      case ModuleType.Gum:
        panels = [
          {
            Title: "Получение билетов",
            Options: [
              {
                Title: "Телеграмм бот",
                To: { name: "Telegram" },
                Icon: "mdi-forum",
              },
              {
                Title: "Поиск по реквизитам",
                To: { name: "GetByOrderInfo" },
                Icon: "mdi-text-box-search-outline",
              },
            ],
          },
        ];
        break;
      case ModuleType.Vdnh:
        panels = [
          {
            Title: "Получение билетов",
            Options: [
              {
                Title: "Телеграмм бот",
                To: { name: "Telegram" },
                Icon: "mdi-forum",
              },
              {
                Title: "Поиск по реквизитам",
                To: { name: "GetByOrderInfo" },
                Icon: "mdi-text-box-search-outline",
              },
            ],
          },
        ];
        break;
      case ModuleType.AkvaLushniki:
        panels = [
          {
            Title: "Получение билетов",
            Options: [
              {
                Title: "Телеграмм бот",
                To: { name: "Telegram" },
                Icon: "mdi-forum",
              }
            ],
          },
          {
            Title: "Возврат билетов",
            Options: [
              {
                Title: "По реквизитам",
                To: { name: "RefundByOrderInfo" },
                Icon: "mdi-text-box-search-outline",
              },
            ],
          },
        ];
        break;
      case ModuleType.LuzhnikiKatok:
        panels = [
          {
            Title: "Получение билетов",
            Options: [
              {
                Title: "Телеграмм бот",
                To: { name: "Telegram" },
                Icon: "mdi-forum",
              },
              {
                Title: "Поиск по реквизитам",
                To: { name: "GetByOrderInfo" },
                Icon: "mdi-text-box-search-outline",
              },
            ],
          },
          {
            Title: "Возврат билетов",
            Options: [
              {
                Title: "По реквизитам",
                To: { name: "RefundByOrderInfo" },
                Icon: "mdi-text-box-search-outline",
              },
            ],
          },
        ];
        break;
      case ModuleType.BobrLog:
        panels = [
          {
            Title: "Получение билетов",
            Options: [
              {
                Title: "Телеграмм бот",
                To: { name: "Telegram" },
                Icon: "mdi-forum",
              },
              {
                Title: "Поиск по реквизитам",
                To: { name: "GetByOrderInfo" },
                Icon: "mdi-text-box-search-outline",
              },
            ],
          },
        ];
        break;
      case ModuleType.LuzhnikiSber:
        panels = [
          {
            Title: "Получение билетов",
            Options: [
              {
                Title: "Телеграмм бот",
                To: { name: "Telegram" },
                Icon: "mdi-forum",
              },
              {
                Title: "Поиск по реквизитам",
                To: { name: "GetByOrderInfo" },
                Icon: "mdi-text-box-search-outline",
              },
            ],
          },
          {
            Title: "Возврат билетов",
            Options: [
              {
                Title: "По реквизитам",
                To: { name: "RefundByOrderInfo" },
                Icon: "mdi-text-box-search-outline",
              },
            ],
          },
        ];
        break;
      case ModuleType.Buhtagold:
        panels = [
          {
            Title: "Получение билетов",
            Options: [
              {
                Title: "Телеграмм бот",
                To: { name: "Telegram" },
                Icon: "mdi-forum",
              },
              {
                Title: "Поиск по реквизитам",
                To: { name: "GetByOrderInfo" },
                Icon: "mdi-text-box-search-outline",
              },
            ],
          },
        ];
        break;
      case ModuleType.Elbrus:
        panels = [
          {
            Title: "Получение билетов",
            Options: [
              {
                Title: "Поиск по реквизитам",
                To: { name: "GetByOrderInfo" },
                Icon: "mdi-text-box-search-outline",
              },
            ],
          },
        ];
        break;
      case ModuleType.PrimorskyOceanarium:
        panels = [
          {
            Title: "Получение билетов",
            Options: [
              {
                Title: "Поиск по реквизитам",
                To: { name: "GetByOrderInfo" },
                Icon: "mdi-text-box-search-outline",
              },
            ],
          },
        ];
        break;
    }

    if (!AppSettings.TelegramBotEnabled) {
      panels.forEach((panel) => {
        if (panel.Options) {
          panel.Options = panel.Options.filter(
            (option) => option.Title !== "Телеграмм бот",
          );
        }
      });

      panels = panels.filter(
        (panel) => panel.Options && panel.Options.length > 0,
      );
    }

    return panels;
  }
  FooterCopyright: string =
    "Сервис поддержки клиентов © " + new Date().getFullYear();
}

class Category {
  Title!: string;
  Options?: Array<Subcategory>;
}

class Subcategory {
  Title!: string;
  Subtitle?: string;
  Icon?: string;
  To?: object;
}
